/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ColorWheelIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Color Wheel',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path opacity=".2" d="M32 18a13.953 13.953 0 0 0-4.114-9.9L18 18Z" />
    <path opacity=".33" d="m18 18 9.919 9.869A13.956 13.956 0 0 0 32 18Z" />
    <path opacity=".47" d="M18 18v14a13.955 13.955 0 0 0 9.874-4.087Z" />
    <path opacity=".6" d="M18 32V18l-9.9 9.889A13.96 13.96 0 0 0 18 32Z" />
    <path opacity=".7" d="M18 18H4a13.959 13.959 0 0 0 4.1 9.889Z" />
    <path opacity=".8" d="M18 18 8.09 8.122A13.953 13.953 0 0 0 4 18Z" />
    <path
      d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2Zm0 30A13.991 13.991 0 0 1 8.07 8.144L17.939 18V4H18a14 14 0 0 1 0 28Z"
    />
  </svg>`;
};
